<template>
  <v-dialog
    :value="visiblePopup"
    @click:outside="onOkClickButton"
    @keydown.esc='onOkClickButton'
    :max-width="400"
  >
    <v-card class="popup-wrapper">
      <div class="title">{{$t(title)}}</div>
      <div class="message">
        <div class='leak-data-popup'>
          <div class='leak-data-popup__row' v-for='(leak, index) in getFormattedLeakData' :key='`leak-data-popup-row-${index}`'>
            <div class='leak-data-popup__row__data'>
              <v-icon small class="material-icons-outlined">{{ leakIcon }}</v-icon>
              <div class='leak-data-popup__row__data__content'>{{leak}}</div>
            </div>
            <div class='leak-data-popup__row__actions'>
              <v-btn icon class="copy-btn" target="_blank" @click="copyData(index)" :ripple="false">
                <v-icon>content_copy</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
        <div class="buttons">
          <v-btn small depressed class="yes-button btn-primary" @click="onOkClickButton()">
            {{$t(okCaption)}}
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>

import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'LeakDataPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    data: {
      type: Array,
      required: true,
    },
    visiblePopup: {
      type: Boolean,
      required: true,
    },
    customTitle: {
      type: String,
      required: false,
      default: 'employees.leak.password.popup.title',
    },
    customLeakIcon: {
      type: String,
      required: false,
      default: 'vpn_key',
    },
  },
  computed: {
    title() {
      return this.customTitle;
    },
    leakIcon() {
      return this.customLeakIcon;
    },
    okCaption() {
      return 'confirm.ok';
    },
    getFormattedLeakData() {
      const formatted = [];
      if (this.data?.length > 0) {
        const seen = new Set();
        this.data.forEach(pass => {
          if (pass.length && !seen.has(pass)) {
            seen.add(pass);
            formatted.push(pass);
          }
        });
      }
      return formatted;
    },

  },
  methods: {
    onOkClickButton() {
      this.$emit('clicked', true);
    },
    copyData(index) {
      const data = this.getFormattedLeakData[index];
      navigator.clipboard.writeText(data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.popup-wrapper {
  max-width: rem(400);
  padding: $space-8 $space-10;
  .title {
    color: var(--text-primary);
    font-size: $space-5;
    font-family: $font-family-bold;
    letter-spacing: 1.12px;
    line-height: $space-4;
    text-transform: uppercase;
    padding-bottom: rem(23);
  }
  .message {
    font-size: $font-size-base;
    font-weight: normal;
    color: var(--text-primary);
    letter-spacing: 0;
    line-height: rem(18);
    .leak-data-popup{
      display: flex;
      flex-direction: column;
      &__row{
        display: flex;
        flex-direction: row;
        border-bottom: $border-width-thin solid var(--border-primary);
        padding-bottom: rem(10);
        padding-top: rem(10);
        justify-content: space-between;
        &__data{
          margin-right: $space-1-5;
          display: flex;
          .v-icon {
            margin-right: rem(10);
            color: var(--text-secondary);
          }
          font-family: $font-family-medium;
          font-size: $space-4;
          color: var(--text-primary);
          &__content{
            max-width: rem(250);
            align-self:center;
          }
        }
        &__actions {
          .copy-btn {
            background-color: var(--btn-action-bg) !important;
            box-shadow: none;
            letter-spacing: 1.07px;
            line-height: $space-4;
            text-align: center;
            text-transform: uppercase;
            min-width: rem(28);
            max-width: rem(28);
            min-height: rem(28);
            max-height: rem(28);
            color: var(--btn-action-border-color) !important;
            :deep(.v-icon) {
              font-size: $space-4;
              color: var(--btn-action-border-color) !important;
            }
            &:hover {
              cursor: pointer;
              border: 1px solid var(--btn-action-bg);
              background-color: var(--btn-action-hover-bg) !important;
            }
            &:active{
              background-color: var(--btn-action-hover-bg) !important;
            }
          }
        }
      }
    }
  }
  .buttons {
    text-align: right;
    padding-top: rem(30);
    .yes-button {
      height: $btn-height-md;
      width: rem(51);
      border-radius: $radius-sm;
      background-color: var(--brand-primary) !important;
      box-shadow: $shadow-sm;
      color: var(--text-inverse);
      font-size: $font-size-xs;
      font-weight: 500;
      letter-spacing: 1.07px;
      line-height: $space-4;
      text-align: center;
      margin-left: $space-2;
    }
  }
}

</style>
